import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { FaRegTrashCan } from 'react-icons/fa6';
import { ConfirmationModal } from '@/components/helpers/ConfirmationModal';

interface DeleteArticleModalProps {
  isOpen: boolean;
  onClose: () => void;
  articleId: string;
  articleTitle: string;
}

export function DeleteArticleModal({
  isOpen,
  onClose,
  articleId,
  articleTitle,
}: DeleteArticleModalProps) {
  const utils = trpc.useUtils();

  const deleteMutation = trpc.admin.article.deleteArticle.useMutation({
    onSuccess: () => {
      utils.admin.article.getArticles.invalidate();
      onClose();
      toast.success('Article deleted successfully!');
    },
    onError: (err) => {
      toast.error(`Failed to delete article: ${err.message}`);
    },
  });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => deleteMutation.mutate({ id: articleId })}
      title="Delete Article?"
      description="This article will be permanently deleted and cannot be restored."
      confirmText="Delete"
      cancelText="Cancel"
      icon={
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center">
          <FaRegTrashCan className="w-9 h-9 text-red-500" />
        </div>
      }
      isLoading={deleteMutation.isPending}
      highlightBox={{ text: articleTitle }}
    />
  );
}